<!-- page starts-->
    <section class="page-wrapper">
      <div class="checkout-center-section myaddress cf">
      	 <div class="container">
      	 	<div class="checkout-center-detail cf">
      	 		<div class="checkout-center-detail-left">
      	 			<div class="checkout-center-detail-address">
      	 				<div class="checkout-center-detail-address-titel">
      	 					<h2>My Address</h2>
      	 				</div>
      	 				<div class="myaddress-detail-section cf">
      	 					<div class="myaddress-detail-box">
      	 						<div class="myaddress-radio-btn-box">
      	 							<div class="myaddress-radio-btn-box-top">
	      	 							<label class="container"><h3>Tom Curran</h3>
	      	 								<p>Hurst Cross Stadium, Surrey Street,Ashton-under-Lyne, Greater Manchester, OL6 8DY</p>
										  <input type="radio" checked="checked" name="radio">
										  <span class="checkmark"></span>
										</label>
									</div>
									<div class="myaddress-radio-btn-box-bottom">
										<ul>
											<li><a href="#">Edit  </a></li>
											<li><a href="#">Remove</a></li>
										</ul>
									</div>
      	 						</div>
      	 						<div class="myaddress-radio-btn-box">
      	 							<div class="myaddress-radio-btn-box-top">
	      	 							<label class="container"><h3>Tom Curran</h3>
	      	 								<p>Hurst Cross Stadium, Surrey Street,Ashton-under-Lyne, Greater Manchester, OL6 8DY</p>
										  <input type="radio" checked="checked" name="radio">
										  <span class="checkmark"></span>
										</label>
									</div>
									<div class="myaddress-radio-btn-box-bottom">
										<ul>
											<li><a href="#">Edit  </a></li>
											<li><a href="#">Remove</a></li>
										</ul>
									</div>
      	 						</div>
      	 					</div>
      	 				</div>
      	 			</div>
      	 			<div class="checkout-center-detail-address-btn">
      	 				<a href="#">Confirm</a>
      	 			</div>
      	 		</div>
      	 		<div class="checkout-center-detail-right">
      	 			<div class="checkout-center-detail-right-myaddress-btn">
      	 				<a href="#login-box" class="popup-login">Add Address</a>
      	 			</div>
      	 		</div>
      	 	</div>
      	 </div>
      </div>
    </section><!-- page ends-->
    <div class="login-section forlogin-section  mfp-hide" id="login-box">
      <div class="add-popup cf">
            <div class="container">
               <div class="checkout-center-detail-popup">  
                  <h2>Add New Address</h2>
                  <form>
                        <div class="checkout-center-detail-address-box cf">
                                <div class="checkout-address-box half">
                                  <input type="text" name="" placeholder="First Name" class="input-style"> 
                                </div>  
                                <div class="checkout-address-box half">
                                  <input type="text" name="" placeholder="last Name" class="input-style"> 
                                </div>  
                                <div class="checkout-address-box full">
                                  <input type="text" name="" placeholder="company" class="input-style"> 
                                </div>
                                <div class="checkout-address-box full">
                                  <input type="text" name="" placeholder="Address1" class="input-style"> 
                                </div>
                                <div class="checkout-address-box full">
                                  <input type="text" name="" placeholder="Address2" class="input-style"> 
                                </div>
                                <div class="checkout-address-box full">
                                  <input type="text" name="" placeholder="City" class="input-style"> 
                                </div>
                                <div class="checkout-address-box half">
                                  <input type="text" name="" placeholder="Country" class="input-style"> 
                                </div>
                                <div class="checkout-address-box half">
                                  <input type="text" name="" placeholder="Post Code" class="input-style"> 
                                </div>
                                <div class="checkout-address-box full">
                                  <input type="text" name="" placeholder="Phone" class="input-style"> 
                                </div>
                                <div class="checkout-address-box-btn">
                                    <a href="#">Submit</a>
                                </div>
                        </div>
                  </form>
               </div>
            </div>
      </div>
    </div>
